/* eslint-disable react/no-unescaped-entities */
import { ManageProfileModel } from "ps-shared";
import React, { ReactNode } from "react";
import { Col, Container, Row } from "reactstrap";
import { CognitoSession } from "src/models/CognitoSession";
import { GettingStartedVector } from "./GettingStartedVector";

interface ManageProfilesProps {
  session: CognitoSession;
}
interface ManageProfilesState {
  loading: boolean;
  profiles: ManageProfileModel[];
  hasPractionerProfile: boolean;
}

export class GettingStarted extends React.Component<ManageProfilesProps, ManageProfilesState> {
  constructor(props: ManageProfilesProps) {
    super(props);
    this.state = {
      loading: false,
      profiles: [],
      hasPractionerProfile: true,
    };
  }

  // tslint:disable:max-line-length
  public render(): ReactNode {
    return (
      <Container className="getting-started">
        <Row>
          <Col>
            <h3 className="cta fw500">Ready to get started with Psychedelic Support?</h3>
            <div className="mt-2">
              We're glad you're here! Use the map below as a guide for your psychedelic explorations.
            </div>
          </Col>
        </Row>
        <Row className="mt-5">
          <Col>
            <div className="v">
              <GettingStartedVector />
            </div>
          </Col>
        </Row>
      </Container>
    );
  }
}
